import React from 'react';

import { Link } from 'react-router-dom';

import useSystemBranding from '../hooks/useSystemBranding';

interface BrandLinkProps {
  showText?: boolean;
  className?: string;
  logoClassName?: string;
}

const BrandLink: React.FC<BrandLinkProps> = ({
  showText = true,
  className,
  logoClassName,
}) => {
  const { logoSrc, companyName } = useSystemBranding();

  return (
    <Link
      to="/dashboard"
      className={`flex items-center gap-2 ${className ?? ''}`}
    >
      <img
        src={logoSrc}
        alt={companyName ?? 'Fade Out'}
        className={logoClassName ?? 'h-8 w-auto object-contain'}
      />
      {showText && (
        <span className="text-lg font-bold text-[var(--color-brand-600)] dark:text-[var(--color-brand-400)]">
          FadeOut
        </span>
      )}
    </Link>
  );
};

export default BrandLink;
